import { AfterLoadEventHandler, CreateOptionsParams, ISpecializedCombo, useCombo } from '@hooks/useCombo';
import { MenuItem } from '@material-ui/core';
import { useRemessaService } from '@services/RemessaService';
import { useThemeColor } from '@themes/Colors';
import { KeyOfEnum } from '@utils/TypeHelpers';
import React from 'react';

export enum EnumRemessaStatus {
    None = 0,
    NaoEnviada = 1,
    Enviada = 2
}

export interface IRemessaStatus {
    remessaStatusId: EnumRemessaStatus
    nome: string
    ativo: string
}

export type IComboRemessaStatus = ISpecializedCombo<IRemessaStatus>;

export function useRemessaStatusCombo (initialValue?: EnumRemessaStatus) : IComboRemessaStatus {
    const combo = useCombo<IRemessaStatus>({
        value: initialValue
    });

    const remessaService = useRemessaService();

    const createOptions = React.useCallback((params?: CreateOptionsParams) => {
        return combo.set.map((remessa, index) => {
            return <MenuItem key={index} value={remessa.remessaStatusId}>{params?.prefix}{remessa.nome}{params?.sufix}</MenuItem>
        });
    }, [combo.set]);

    const loadOptions = React.useCallback((afterLoad?: AfterLoadEventHandler<IRemessaStatus>) => {
        combo.load(remessaService.listarStatusAtivos, afterLoad)
    }, [combo, remessaService.listarStatusAtivos]);

    return React.useMemo(() => ({
        ...combo, createOptions, loadOptions
    }), [combo, createOptions, loadOptions]);
}

export function useRemessaStatusColor () {
    const themeColor = useThemeColor();

    const map : KeyOfEnum<EnumRemessaStatus, string> = React.useMemo(() => ({
        [EnumRemessaStatus.None]: "",
        [EnumRemessaStatus.NaoEnviada]: themeColor.status.vermelho,
        [EnumRemessaStatus.Enviada]: themeColor.status.verde,
    }), [themeColor.status.verde, themeColor.status.vermelho]);

    return React.useMemo(() => map, [map]);
}